import type { CityConfig } from "@/pages/city-template/types";

export const gooseCreekConfig: CityConfig = {
  vitalRecordsIcon: "ri-file-text-line",
  city: "Goose Creek",
  state: "South Carolina",
  stateAbbr: "SC",
  slug: "goose-creek",
  route: "/goose-creek",
  title: "Emergency Passport Goose Creek, SC — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Goose Creek, SC — as fast as 24 hours. Fast Passport Center couriers to the Charleston Passport Center at 196 E Bay St. A+ BBB rated. Serving Berkeley County families, Naval Weapons Station personnel, Joint Base Charleston military travelers, and Lowcountry professionals.",
  h1: "Emergency & Expedited Passport Services in Goose Creek, SC",
  heroSubtitle: "Goose Creek is Berkeley County's largest city, a thriving Lowcountry community just 20 miles from Charleston known for the Naval Weapons Station and Joint Base Charleston. Fast Passport Center's registered couriers deliver your documents to the Charleston Passport Center at 196 E Bay St so you get a new or renewed passport as fast as 24 hours — whether you're a Goose Creek military family with overseas PCS orders, a Berkeley County professional heading to a European conference from CHS, or a Lowcountry couple planning a Caribbean destination wedding.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Goose%20Creek%20South%20Carolina%20Lowcountry%20suburban%20landscape%20with%20oak%20trees%20draped%20in%20Spanish%20moss%20along%20quiet%20residential%20streets%20at%20golden%20hour%2C%20brick%20homes%20with%20manicured%20lawns%20in%20Berkeley%20County%20neighborhood%2C%20southern%20charm%20with%20warm%20sunlight%20filtering%20through%20live%20oak%20canopy%2C%20peaceful%20suburban%20scene%20near%20Charleston%20SC&width=1800&height=700&seq=goosecreek-sc-hero-001&orientation=landscape",
  heroImageAlt: "Goose Creek South Carolina Lowcountry suburban landscape with live oaks and Spanish moss at golden hour",
  geoPosition: "32.9810;-80.0326",
  geoPlacename: "Goose Creek, South Carolina",
  lastModified: "2026-06-14",
  regionalAgency: {
    name: "Charleston Passport Center",
    address: "196 E Bay St, Charleston, SC 29401",
    distance: "Approximately 20 miles from Goose Creek — about 25 minutes via US-52 and I-26",
  },
  nearbyCitiesZips: [
    { name: "Goose Creek", zips: "29445" },
    { name: "Hanahan", zips: "29410" },
    { name: "Ladson", zips: "29456" },
    { name: "Summerville", zips: "29483, 29485, 29486" },
    { name: "Moncks Corner", zips: "29461" },
    { name: "North Charleston", zips: "29405, 29406, 29418" },
    { name: "Charleston", zips: "29401, 29403, 29407" },
    { name: "Mount Pleasant", zips: "29464, 29466" },
    { name: "Ridgeville", zips: "29472" },
    { name: "St. Stephen", zips: "29479" },
    { name: "Bonneau", zips: "29431" },
    { name: "Cordesville", zips: "29434" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Courier delivery to Charleston Passport Center — serving Goose Creek and Berkeley County" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-map-pin-2-line", title: "Berkeley County & Joint Base", desc: "Serving Goose Creek, Hanahan, Ladson, Moncks Corner, and military families" },
    { icon: "ri-user-line", title: "Dedicated Agent", desc: "A real person assigned to your Goose Creek case from start to finish" },
  ],
  internalLinks: [
    { name: "Emergency passport in Charleston SC", route: "/charleston" },
    { name: "Expedited passport in Columbia SC", route: "/columbia-sc" },
    { name: "Urgent passport in Goose Creek SC", route: "/goose-creek" },
    { name: "South Carolina passport hub", route: "/south-carolina" },
    { name: "Fast passport in Summerville SC", route: "/summerville" },
    { name: "Expedited passport in Mount Pleasant SC", route: "/mount-pleasant" },
    { name: "Emergency passport in Florence SC", route: "/florence-sc" },
  ],
  fpcOfficeAddress: "196 E Bay St, Charleston, SC 29401",
  fpcOfficeNote: "Fast Passport Center serves Goose Creek remotely via secure courier. Our registered couriers hand-deliver your documents to the Charleston Passport Center at 196 E Bay St — approximately 20 miles away. Goose Creek's location in Berkeley County with easy access to I-26 and proximity to Charleston International Airport (CHS) makes overnight courier routing highly efficient. Our dedicated agents ensure Lowcountry residents — including military families at Joint Base Charleston and NWS personnel — never need to make the drive to Charleston.",
  fpcOfficeDistance: "Serving all of Berkeley County and the Charleston metro Lowcountry",
  serviceAreaIntro: "Fast Passport Center provides emergency and fast passport renewal services throughout Goose Creek, Hanahan, Ladson, Moncks Corner, North Charleston, and the greater Berkeley County area. From Naval Weapons Station military families facing overseas PCS orders to Lowcountry professionals traveling for business, we help Goose Creek residents get their passports fast.",
  nearbyCitiesIntro: "We serve Goose Creek and nearby communities including Hanahan, Ladson, Summerville, Moncks Corner, North Charleston, and the entire Charleston metro area.",
  howItWorksIntro: "Most Goose Creek travelers complete everything online and ship documents overnight. Fast Passport Center provides fast courier turnaround for Berkeley County residents — with the Charleston Passport Center only 20 miles away via US-52 and I-26.",
  mistakesIntro: "Goose Creek travelers, including Joint Base Charleston military personnel, NWS families, and Berkeley County professionals, face unique passport challenges. Here are the most common mistakes we see.",
  testimonialsIntro: "Goose Creek and Berkeley County travelers trust us when their departure is days away. Here is what some of them have to say.",
  faqIntro: "Have questions about expedited passports in Goose Creek? Here are the most common ones we hear from Berkeley County and Lowcountry travelers.",
  statePageRoute: "/states/south-carolina",
  statePageName: "South Carolina",
  dmvWebsite: "https://www.scdmvonline.gov/",
  dmvLabel: "South Carolina DMV — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "No drive or appointment needed",
        "Ideal for military families with PCS orders",
        "Perfect for NWS & Joint Base personnel",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Faster than self-service USPS",
        "Good for planned travel from CHS",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: [
        "No courier access — standard mail only",
        "No document review — errors cause rejection",
        "In-person clerk appointment required",
        "Workload shifts with government shutdowns",
        "No dedicated agent — you are on your own",
        "Updates only by physical mail letter",
        "Cannot upgrade speed after submission",
        "Not suitable if travel is within 10 weeks",
      ],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: [
        "Appointment required — no walk-ins at 230 Peachtree St NW",
        "Life-or-death emergencies only",
        "280 miles to Atlanta (4 hours via I-26 and I-20)",
        "Still requires pre-scheduled NPIC appointment",
      ],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "Goose Creek is 280 miles from the Atlanta Passport Agency — our courier service saves Berkeley County travelers the drive to Atlanta.",
      bullets: ["Berkeley County & Lowcountry coverage", "24–48 hour turnaround available", "No appointment or drive needed"],
      badge: "Fastest in Lowcountry",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for Goose Creek adults with a passport issued within the last 15 years at age 16 or older.",
      bullets: ["No acceptance clerk visit for most renewals", "Mail-in or courier options", "Serving Goose Creek and Berkeley County"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport",
      description: "First-time passport application guidance with acceptance clerk appointment support in Goose Creek and Berkeley County.",
      bullets: ["Acceptance facility locator", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Fast replacement for Goose Creek, Hanahan, and Berkeley County residents with DS-64 form guidance.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement via Atlanta agency"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 with parental consent and acceptance clerk support in Berkeley County.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change",
      description: "Passport name change service after marriage, divorce, or legal changes for Goose Creek and Berkeley County residents.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Goose Creek SC", description: "Urgent passport processing for Goose Creek, SC travelers via Atlanta Passport Agency courier." },
    { name: "Passport Renewal Goose Creek SC", description: "Fast passport renewal for Goose Creek and Berkeley County, South Carolina residents." },
    { name: "New Passport Goose Creek SC", description: "First-time passport application assistance for Goose Creek and Lowcountry area residents." },
    { name: "Lost Passport Goose Creek SC", description: "Passport replacement for lost or stolen passports for Goose Creek and Lowcountry residents." },
    { name: "Child Passport Goose Creek SC", description: "Minor passport services for Goose Creek and Berkeley County families." },
    { name: "Name Change Passport Goose Creek SC", description: "Passport name change service for Goose Creek, SC residents." },
  ],
  testimonials: [
    {
      name: "Sergeant First Class Marcus W.",
      location: "Goose Creek — Naval Weapons Station",
      rating: 5,
      text: "NWS Charleston personnel with PCS orders to Germany on 8 days notice. My wife and I both needed passport renewals and our two kids needed first-time passports. Fast Passport Center handled all four applications simultaneously — renewals in 3 days, first-time in 6. We made the flight to Ramstein without any stress.",
      service: "Military Family PCS",
    },
    {
      name: "Ashley T.",
      location: "Goose Creek — Carnes Crossroads",
      rating: 5,
      text: "Berkeley County mom planning a summer trip to Italy with my daughter. Realized 4 weeks out her passport had less than 5 months validity. Fast Passport Center got her renewal done in 5 business days. Their agent explained the Schengen 6-month validity rule that I had no idea about — saved our entire trip.",
      service: "Renewal for Schengen Travel",
    },
    {
      name: "Lt. Commander James K.",
      location: "Joint Base Charleston Personnel",
      rating: 5,
      text: "Joint Base Charleston officer with no-fail NATO assignment in Brussels requiring an official passport on 5 days' turnaround. Fast Passport Center understood DoD travel requirements and expedited the processing through Atlanta. Documents back in 2 days. Professional service that understands military urgency.",
      service: "Official Military Travel",
    },
    {
      name: "Patricia H.",
      location: "Goose Creek — Boulder Bluff",
      rating: 5,
      text: "Retired teacher from Goose Creek whose passport was lost during a move from Hanahan. Had a cruise booked from Port Canaveral in 2 weeks. Fast Passport Center helped with the lost passport DS-64 form and emergency replacement. New passport arrived in 4 business days. I was on that ship without a worry.",
      service: "Lost Passport Emergency",
    },
  ],
  facilities: [
    {
      id: "gc-1",
      name: "Goose Creek Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "307 N Goose Creek Blvd",
      city: "Goose Creek",
      state: "SC",
      zip: "29445",
      phone: "(843) 553-1574",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Goose Creek — North Goose Creek Boulevard",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary passport acceptance facility for Goose Creek and central Berkeley County residents. Appointment recommended. Located on North Goose Creek Boulevard near downtown Goose Creek.",
      icon: "ri-mail-line",
    },
    {
      id: "gc-2",
      name: "Hanahan Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1000 Tanner Ford Blvd",
      city: "Hanahan",
      state: "SC",
      zip: "29410",
      phone: "(843) 553-7279",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Hanahan — 5 miles south",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for Goose Creek residents in southern Berkeley County near the Hanahan border. Located off Tanner Ford Boulevard. Appointment recommended.",
      icon: "ri-mail-line",
    },
    {
      id: "gc-3",
      name: "Summerville Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "900 N Main St",
      city: "Summerville",
      state: "SC",
      zip: "29483",
      phone: "(843) 871-3044",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Summerville — 7 miles west",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Alternative facility for Goose Creek residents near the Summerville border. Larger post office serving Dorchester County. Appointment required.",
      icon: "ri-mail-line",
    },
    {
      id: "gc-4",
      name: "Moncks Corner Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "128 N Highway 52",
      city: "Moncks Corner",
      state: "SC",
      zip: "29461",
      phone: "(843) 761-8456",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Moncks Corner — 10 miles north",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Berkeley County seat passport acceptance facility. Convenient for northern Goose Creek and Moncks Corner area residents. Appointment recommended.",
      icon: "ri-mail-line",
    },
    {
      id: "gc-5",
      name: "North Charleston Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "7075 Cross County Rd",
      city: "North Charleston",
      state: "SC",
      zip: "29418",
      phone: "(843) 760-5185",
      hours: "Mon–Fri: 9:00 AM – 5:00 PM, Sat: 9:00 AM – 12:00 PM",
      distance: "North Charleston — 12 miles south",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Larger USPS location with Saturday passport hours. Convenient for Goose Creek residents heading south on US-52. One of the few Saturday passport options in the Lowcountry.",
      icon: "ri-mail-line",
    },
    {
      id: "gc-6",
      name: "Dorchester County Library — Summerville Branch",
      type: "Public Library Passport Acceptance",
      address: "76 Old Trolley Rd",
      city: "Summerville",
      state: "SC",
      zip: "29485",
      phone: "(843) 832-3993",
      hours: "Mon–Thu: 10:00 AM – 6:00 PM, Fri–Sat: 10:00 AM – 4:00 PM",
      distance: "Summerville — 8 miles west",
      website: "https://www.dcl.lib.sc.us/",
      websiteLabel: "Dorchester County Library",
      notes: "Library-based passport acceptance with extended evening hours on select days. Convenient for Carnes Crossroads and southern Goose Creek residents near the Summerville line.",
      icon: "ri-building-line",
    },
  ],
  comparisonRows: [
    { feature: "Distance to Atlanta Agency", agency: "280 miles — 4 hour drive via I-26/I-20, but need appointment", fpc: "We drive for you — no appointment needed" },
    { feature: "Appointment Needed", agency: "Yes — call NPIC, very limited slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Guaranteed Timing", agency: "No — subject to availability", fpc: "Yes — contractual turnaround times" },
    { feature: "Military Family Support", agency: "No — generic government service", fpc: "Yes — NWS & Joint Base Charleston PCS expertise" },
    { feature: "Berkeley County Coverage", agency: "No — Berkeley County travelers must drive to Atlanta", fpc: "Yes — full Berkeley County and Lowcountry coverage" },
  ],
  mistakes: [
    {
      icon: "ri-ship-line",
      title: "Military Families Not Checking Passports Before PCS Orders Arrive",
      description: "Goose Creek is home to the Naval Weapons Station Charleston and the area around Joint Base Charleston. Military families receiving overseas PCS orders to Germany, Italy, Japan, or South Korea often have just days to weeks of notice. Not having current passports — or passports with at least 6 months remaining validity — can delay an entire family's permanent change of station move.",
    },
    {
      icon: "ri-global-line",
      title: "Civilian DoD Contractors Confusing Official Passport vs Tourist Passport",
      description: "DoD civilian employees and contractors working at NWS Charleston and Joint Base Charleston traveling on official orders need to understand the difference between a tourist passport (blue) and official/no-fee passport (maroon). Using the wrong passport type for official travel causes processing delays and can require starting the application completely over.",
    },
    {
      icon: "ri-image-line",
      title: "Using Chain Store Photos That Don't Meet State Department Standards",
      description: "Goose Creek residents often get passport photos from nearby retail chains where staff may not be properly trained on exact State Department specifications. Photos must be exactly 2x2 inches, pure white background, neutral expression, no glasses, and no shadows. A rejected photo means your application gets returned and processing restarts from day one.",
    },
    {
      icon: "ri-restart-line",
      title: "Waiting Until the Week Before a Cruise From Charleston to Check Passports",
      description: "Many Goose Creek families book cruises departing from the nearby Port of Charleston without checking passport expiration dates. While some closed-loop cruises accept birth certificates, most Caribbean and international itineraries require valid passports. Airlines will deny boarding if your passport has less than 6 months validity beyond the return date.",
    },
    {
      icon: "ri-file-list-line",
      title: "Renewing by Mail When In-Person (DS-11) Is Required",
      description: "Goose Creek residents whose previous passport expired more than 5 years ago, was issued before age 16, or reflects a name change without legal documentation must use Form DS-11 at an acceptance facility — not the mail-in DS-82. Filing the wrong form results in automatic rejection and restarting the process, wasting weeks of precious time.",
    },
    {
      icon: "ri-calendar-line",
      title: "Not Realizing Both Parents Must Be Present for Child Passport Applications",
      description: "For children under 16, both parents or legal guardians must appear in person at the acceptance facility with the child. Goose Creek military families with one parent deployed or TDY face additional documentation requirements — a notarized DS-3053 Statement of Consent is required from the absent parent. Many families don't discover this until they're at the post office counter.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send a prepaid overnight label. Drop at any UPS location in Goose Creek, Hanahan, or North Charleston." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team reviews every document, then couriers to the Atlanta Passport Agency — 280 miles via I-26 and I-20." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at the Atlanta Passport Agency via our pre-secured courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Goose Creek or Berkeley County address — fully trackable." },
  ],
  faqs: [
    {
      q: "How far is Goose Creek from the Atlanta passport agency?",
      a: "Goose Creek is approximately 20 miles from the Charleston Passport Center at 196 E Bay St — about a 25 minute drive via US-52 and I-26. Goose Creek's access to I-26 via US-52 makes the route to downtown Charleston straightforward, but the Charleston Passport Center requires pre-scheduled appointments and absolutely no walk-ins.",
    },
    {
      q: "Does Goose Creek, SC have its own passport agency?",
      a: "No. Goose Creek does not have a regional passport agency. The closest passport agency is the Charleston Passport Center at 196 E Bay St, Charleston, SC 29401 — about 20 miles away. Goose Creek only has passport acceptance facilities — the Goose Creek Post Office on North Goose Creek Boulevard and neighboring facilities in Hanahan and Summerville — which accept DS-11 applications but cannot process or expedite them.",
    },
    {
      q: "I'm military stationed at NWS Charleston with overseas PCS orders — how fast can I get passports?",
      a: "Military families at Naval Weapons Station Charleston facing overseas PCS orders can get emergency passport processing in 24–48 hours. Fast Passport Center has extensive experience handling military family passport needs — including simultaneous applications for service members, spouses, and children — and understands PCS documentation requirements. We've helped countless Goose Creek military families make their overseas reporting dates.",
    },
    {
      q: "Where do Goose Creek travelers typically fly internationally?",
      a: "Goose Creek residents primarily use Charleston International Airport (CHS), only about 15–20 minutes south via US-52 and I-526. CHS offers growing international service to the Caribbean, seasonal European routes, and extensive domestic connections through major hubs. Some travelers also use Savannah/Hilton Head International (SAV, about 90 minutes away) or Charlotte Douglas International (CLT, about 3 hours away) for more international route options.",
    },
    {
      q: "How fast can I get an emergency passport in Goose Creek?",
      a: "Emergency processing is typically 24–48 hours for Goose Creek residents. Goose Creek's location in the Charleston metro with access to major overnight shipping infrastructure makes courier routing highly reliable. Standard expedited processing runs 2–9 business days. Our courier service eliminates the 280-mile drive to Atlanta.",
    },
    {
      q: "Where can I get passport photos in Goose Creek?",
      a: "Walgreens at 210 St James Ave in Goose Creek, CVS Pharmacy on Red Bank Road, and several UPS Store locations in the North Charleston and Summerville area offer passport photo services. Walmart on North Main Street in Summerville also provides photos. Always verify your photos meet exact 2x2 inch specifications with a pure white background.",
    },
    {
      q: "Does the Goose Creek Post Office take walk-in passport appointments?",
      a: "The Goose Creek Post Office at 307 N Goose Creek Blvd accepts passport applications by appointment Monday through Friday from 9:00 AM to 4:00 PM. Walk-ins are generally not accepted — call (843) 553-1574 to schedule. This location serves the growing Berkeley County population and can be particularly busy during spring and summer months.",
    },
    {
      q: "Can the Hanahan Post Office process my passport?",
      a: "Yes. The Hanahan Post Office at 1000 Tanner Ford Blvd is just 5 miles south of Goose Creek and offers passport acceptance services. This facility is convenient for Goose Creek residents in the southern part of the city near the Hanahan border. Call (843) 553-7279 to confirm availability and schedule an appointment.",
    },
    {
      q: "I'm a DoD contractor at Joint Base Charleston — what passport type do I need?",
      a: "DoD civilian employees and contractors traveling on official orders typically require an official (no-fee) passport for military-related travel, not a standard tourist passport. However, if your official travel includes personal leave time, you may need both. Fast Passport Center can help you determine which passport type applies to your specific travel orders and process accordingly.",
    },
    {
      q: "Can Fast Passport Center help Ladson and Moncks Corner residents too?",
      a: "Absolutely. We serve all of Berkeley County including Goose Creek, Hanahan, Ladson, Moncks Corner, St. Stephen, Bonneau, Cordesville, and surrounding areas. Residents of these communities never need to drive to Goose Creek or Atlanta for expedited passport service — everything is handled via secure courier.",
    },
    {
      q: "Is there an acceptance facility near Goose Creek with Saturday hours?",
      a: "Yes. The North Charleston Main Post Office at 7075 Cross County Rd offers Saturday passport acceptance from 9:00 AM to 12:00 PM — one of the only Saturday passport options in the Charleston metro area. It's about a 15-minute drive from Goose Creek via US-52. The Goose Creek and Hanahan post offices do not offer Saturday passport hours.",
    },
    {
      q: "What if my spouse is deployed and I need a passport for our child?",
      a: "For children under 16, both parents must appear in person or provide a notarized DS-3053 Statement of Consent from the absent parent. Goose Creek military families with a deployed parent can have the deployed parent complete and notarize the DS-3053 at their duty station's legal office. Fast Passport Center can guide you through this specific military family scenario.",
    },
  ],
  photoLocations: [
    { name: "Walgreens — Goose Creek", address: "210 St James Ave, Goose Creek, SC 29445", hours: "Mon–Sun: 7AM–10PM", website: "https://www.walgreens.com/" },
    { name: "CVS Pharmacy — Hanahan", address: "1000 Tanner Ford Blvd, Hanahan, SC 29410", hours: "Mon–Sun: 8AM–9PM", website: "https://www.cvs.com/" },
    { name: "Walmart Photo — Summerville", address: "1318 N Main St, Summerville, SC 29483", hours: "Mon–Sun: 7AM–9PM", website: "https://www.walmart.com/" },
    { name: "Walgreens — North Charleston", address: "7555 Dorchester Rd, North Charleston, SC 29418", hours: "Mon–Sun: 7AM–10PM", website: "https://www.walgreens.com/" },
    { name: "UPS Store — North Charleston", address: "5900 Core Ave, North Charleston, SC 29406", hours: "Mon–Fri: 8AM–6PM, Sat: 9AM–2PM", website: "https://www.theupsstore.com/" },
    { name: "CVS Pharmacy — Summerville", address: "1310 N Main St, Summerville, SC 29483", hours: "Mon–Sun: 8AM–9PM", website: "https://www.cvs.com/" },
  ],
  dmvLocations: [
    { name: "SC DMV — Moncks Corner", address: "223 N Live Oak Dr, Moncks Corner, SC 29461", hours: "Mon–Fri: 8:30AM–5:00PM", note: "Primary SC DMV branch serving Berkeley County residents including Goose Creek. REAL ID, driver's license, and state ID services. About a 10-minute drive north.", featured: true },
    { name: "SC DMV — Summerville", address: "1341 College Park Rd, Summerville, SC 29486", hours: "Mon–Fri: 8:30AM–5:00PM", note: "Convenient DMV branch near Nexton area. About 15 minutes from Goose Creek via US-52. Full service including REAL ID.", featured: false },
    { name: "SC DMV — North Charleston", address: "3811 Leeds Ave, North Charleston, SC 29405", hours: "Mon–Fri: 8:30AM–5:00PM", note: "Major DMV branch serving the Charleston metro. About 20 minutes from Goose Creek via I-526. Full service including REAL ID.", featured: false },
  ],
  airports: [
    {
      code: "CHS",
      name: "Charleston International Airport",
      distance: "15 miles south of Goose Creek",
      address: "5500 International Blvd, North Charleston, SC 29418",
      note: "The primary airport serving Goose Creek and the entire Lowcountry. Only 15–20 minutes via US-52 and I-526. Growing international service with routes to the Caribbean, seasonal European service, and extensive domestic connections. Joint Base Charleston shares the airfield.",
      flightUrl: "https://www.iflychs.com/",
      flightLabel: "CHS Airport",
      featured: true,
    },
    {
      code: "SAV",
      name: "Savannah/Hilton Head International Airport",
      distance: "95 miles south of Goose Creek",
      address: "400 Airways Ave, Savannah, GA 31408",
      note: "Regional airport with domestic routes and some seasonal international service. About 1 hour 45 minutes via I-95. Alternative for southern Lowcountry residents.",
      flightUrl: "https://savannahairport.com/",
      flightLabel: "SAV Airport",
      featured: false,
    },
    {
      code: "CAE",
      name: "Columbia Metropolitan Airport",
      distance: "95 miles northwest of Goose Creek",
      address: "3250 Airport Blvd, West Columbia, SC 29170",
      note: "South Carolina's second-busiest airport with domestic routes. About 1 hour 30 minutes via I-26. Alternative for Midlands residents.",
      flightUrl: "https://flycae.com/",
      flightLabel: "CAE Airport",
      featured: false,
    },
    {
      code: "CLT",
      name: "Charlotte Douglas International Airport",
      distance: "185 miles north of Goose Creek",
      address: "5501 R C Josh Birmingham Pkwy, Charlotte, NC 28208",
      note: "Major international hub with the most extensive international route network accessible to Lowcountry travelers. About 3 hours via I-26 and I-77. American Airlines hub with worldwide connections.",
      flightUrl: "https://www.cltairport.com/",
      flightLabel: "CLT Airport",
      featured: false,
    },
  ],
  vitalRecordsLinks: [
    { icon: "ri-user-smile-line", label: "Birth & Death Certificates", desc: "Order certified South Carolina birth and death certificates from the SC Department of Health and Environmental Control Vital Records — online, by mail, or in person.", url: "https://scdhec.gov/vital-records" },
    { icon: "ri-hearts-line", label: "Marriage Records", desc: "Request certified marriage certificates from the Berkeley County Probate Court in Moncks Corner. Required for name change passport applications.", url: "https://www.berkeleycountysc.gov/" },
    { icon: "ri-file-copy-line", label: "Divorce Decrees", desc: "Obtain certified divorce records through the Berkeley County Family Court. Required for name change passport corrections.", url: "https://www.sccourts.org/" },
    { icon: "ri-global-line", label: "VitalChek — Nationwide Records", desc: "If your record was issued outside South Carolina, order certified copies online through VitalChek for delivery in 5–10 business days.", url: "https://www.vitalchek.com/" },
  ],
};